'use strict';
/* ==========================================================================
   levels/map.js — the hub of "Who Eats Whom?" (food-web): the field notebook's CONTENTS page (DESIGN.md §1–§2).
   One entry per lesson.json step (a new step shows up by itself): a green wax-seal number, the step title hand-lettered,
   its tag typed, a dotted leader, and on the right the FIELD-CHECKED stamp once the step is stamped (its score when
   Game.progress.scores[id] = {best, of}); a red pencil "next!" arrow at the first entry not done. A small plate beside
   each entry (the snail kite, a gopher tortoise, the raccoon, the panther). Mr. Mendoza stands at the left with a speech
   bubble. An entry → Game.replace(new Levels[id]()); keys 1–4, Enter = the next entry. On a phone held upright the
   entries are rows in the portrait dock (Dock.map) and the page is only the picture (no hit areas, no bubble).
   ========================================================================== */
(function () {
  const PL = () => window.Plate, K = () => window.WebKit;
  const PAGE = { x: 1120, y: 560, w: 1240, h: 860 };
  const PICS = ['snail_kite', 'gopher_tortoise', 'raccoon', 'panther'];
  const SAY = {
    hello: 'The notebook is open. Start at entry one and follow the arrows.',
    next: 'Good notes. The next entry is marked.',
    done: 'Every entry field-checked. The marsh thanks you.',
  };

  /* the entries, laid out from lesson.json steps (numbers count the steps that earn a stamp, like the home page) */
  function entries() {
    const S = (Game.lesson && Game.lesson.steps) || [], n = Math.max(1, S.length);
    const top = PAGE.y - PAGE.h / 2 + 190, rowH = Math.min(150, (PAGE.h - 230) / n);
    let k = 0;
    return S.map((s, i) => {
      const stamps = s.stamp !== false; if (stamps) k++;
      return { id: s.id, n: stamps ? k : null, title: s.title, tag: s.tag || '', x: PAGE.x, y: top + rowH * (i + 0.5), w: PAGE.w - 120, h: Math.max(rowH - 14, 100), pic: PICS[i % PICS.length] };
    });
  }
  const nextEntry = () => entries().find(e => e.n != null && !Game.progress.stamps[e.id]);

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps, E_ = entries().filter(e => e.n != null);
      this.allDone = E_.every(e => st[e.id]);
      this.say = this.allDone ? SAY.done : E_.some(e => st[e.id]) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
      if (K()) K().load();
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const all = entries(), n = parseInt(k, 10);
      if (n >= 1 && n <= all.length) this.open(all[n - 1].id);
      if (k === 'Enter') this.open((nextEntry() || all[0]).id);
    }

    draw() {
      UI.allLessons();
      const t0 = this.enteredAt, t = this.t, docked = UI.docked(), Pl = PL(), C = Pl.C, Kt = K();
      Pl.backdrop(t0);
      // the notebook page: a kraft cover edge, the cream page, faint rules, a red margin
      const s = pop(T, t0 + 0.05, 0.4, 1.6);
      g.save(); g.translate(PAGE.x, PAGE.y); g.scale(s, s); g.translate(-PAGE.x, -PAGE.y);
      paperRect(PAGE.x + 12, PAGE.y + 10, PAGE.w + 30, PAGE.h + 24, '#6e4f30', { seed: 501, depth: 1.5, boil: false, rot: 0.004 });
      paperRect(PAGE.x, PAGE.y, PAGE.w, PAGE.h, '#f4ead1', { seed: 502, depth: 0.6, boil: false });
      g.save(); g.strokeStyle = 'rgba(31,95,107,0.13)'; g.lineWidth = 2;
      for (let y = PAGE.y - PAGE.h / 2 + 150; y < PAGE.y + PAGE.h / 2 - 20; y += 44) { g.beginPath(); g.moveTo(PAGE.x - PAGE.w / 2 + 20, y); g.lineTo(PAGE.x + PAGE.w / 2 - 20, y); g.stroke(); }
      g.strokeStyle = 'rgba(168,50,42,0.3)'; g.beginPath(); g.moveTo(PAGE.x - PAGE.w / 2 + 110, PAGE.y - PAGE.h / 2 + 10); g.lineTo(PAGE.x - PAGE.w / 2 + 110, PAGE.y + PAGE.h / 2 - 10); g.stroke();
      g.restore();
      g.restore();
      Pl.label('CONTENTS', PAGE.x, PAGE.y - PAGE.h / 2 + 78, 50, { t0: t0 + 0.2, seed: 304, rot: -0.01 });
      if (Kt) Kt.pin(PAGE.x + 6, PAGE.y - PAGE.h / 2 + 46);
      hand('Field notes · Everglades National Park', PAGE.x, PAGE.y - PAGE.h / 2 + 140, 34, t0 + 0.4, { color: C.leafDark, seed: 306 });

      // Mr. Mendoza + speech (the speech goes into the dock when docked)
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('mendoza', 230, 1080 + (1 - rise) * 500, 700, { facing: 1, t: T, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (docked) Dock.map({ say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.mendoza || {}).name, open: id => this.open(id) });
      else if (t > 0.6) UI.speech(this.say, 270, 250, { side: 'left', w: 420, t0: t0 + 0.6 });

      const nx = nextEntry(), lab = (Game.lesson.completeCard && Game.lesson.completeCard.title) || 'FIELD-CHECKED';
      entries().forEach((e, i) => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('entry' + i, e.x, e.y, e.w, Math.max(e.h, UI.tap(100)));
        if (hit.hover && !this['hov' + i]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + i] = hit.hover;
        const es = pop(T, t0 + 0.35 + i * 0.12, 0.4, 2.2);
        if (es <= 0) return;
        g.save(); g.translate(e.x, e.y); g.scale(es, es); g.translate(-e.x, -e.y);
        if (hit.hover) { g.save(); g.globalAlpha = 0.35; g.fillStyle = C.yellowPea; g.fillRect(e.x - e.w / 2, e.y - e.h / 2, e.w, e.h); g.restore(); }
        const x0 = e.x - e.w / 2;
        if (e.n != null) Pl.seal(x0 + 44, e.y, 34, { text: String(e.n), seed: 40 + i * 9, color: C.leafDark });
        if (Kt) Kt.plate(e.pic, x0 + 170, e.y, { w: 120, rot: [-0.03, 0.02, -0.015, 0.025][i % 4], pin: true });
        const tx = x0 + 270;
        if (Kt) {
          Kt.text(e.title, tx, e.y - 20, 54, { align: 'left', color: C.ink });
          Kt.text(e.tag, tx, e.y + 30, Kt.fsz(26, 11), { align: 'left', face: Kt.F.type, color: C.pencil || '#6b5e50' });
          // the dotted leader to the right edge
          const tw = Math.max(Kt.measure(e.title, `54px ${Kt.F.hand}`), 10);
          g.save(); g.strokeStyle = 'rgba(58,42,28,0.4)'; g.lineWidth = 3; g.setLineDash([3, 11]); g.lineCap = 'round';
          g.beginPath(); g.moveTo(tx + tw + 24, e.y - 4); g.lineTo(e.x + e.w / 2 - 230, e.y - 4); g.stroke(); g.restore();
        }
        g.restore();
        if (Game.progress.stamps[e.id]) {
          let ss = 1, at = null;
          if (this.stampNew === e.id) {
            at = t0 + 0.9;
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp'); }
          } else ss = pop(T, t0 + 0.8, 0.25, 1.5);
          const sc = Game.progress.scores && Game.progress.scores[e.id];
          if (Kt) Kt.stamp(sc && sc.best != null && sc.of ? `${sc.best}/${sc.of}` : lab, e.x + e.w / 2 - 120, e.y, { t0: at, s: 0.5 * ss, rot: -0.14 });
        }
        if (!this.allDone && !docked && nx && nx.id === e.id) {
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            const ax = e.x + e.w / 2 - 120;
            inkArrow(ax + 70 + bob, e.y - 70, ax + 6, e.y - 8, { w: 6, color: C.red, seed: 600 + i, bulge: -18 });
            hand('next!', ax + 120 + bob, e.y - 86, 44, 0, { dur: 0.01, color: C.red, rot: 0.08, seed: 610 + i });
            g.restore();
          }
        }
        if (hit.clicked) this.open(e.id);
      });
    }
  }
  MapScene.tags = () => entries().map(e => ({ id: e.id, x: e.x, y: e.y }));   // tools/integration.js clicks these

  Levels.map = MapScene;
})();
